// 引入饿了么UI组件库中的message和load
import {Loading, Message, MessageBox} from 'element-ui'
import Axios from 'axios'
import {setLogin} from 'router';


var axios = Axios.create({
  baseURL: '/api/guard',
//   timeout: 30000,
  withCredentials: true,
//   headers: {
//     Accept: "application/json"
//   }
  // headers: {
  //   AccessTokenE: localStorage.getItem('accessTokenE')
  // }
});


// var loadinginstace
//添加一个请求拦截器
axios.interceptors.request.use(function(config){
  let headersObj=new Object();
  if(localStorage.getItem('accessTokenE') ){
    headersObj["AccessTokenE"]=localStorage.getItem('accessTokenE');
  }
  headersObj["ClientAuth"]="Basic eGN3c19yZXBvcnRfd2ViOnhjd3NfcmVwb3J0X3dlYl9zZWNyZXRzZGY=";
  config.headers =headersObj;

  //在请求发出之前进行一些操作
  // loadinginstace = Loading.service({ fullscreen: true })  
  return config;
},function(err){
  //Do something with request error

    // loadinginstace.close();
    Message.error({
        message:"请求超时"
    })
  return Promise.reject(err);
});
//添加一个响应拦截器
axios.interceptors.response.use(function(res){
  //在这里对返回的数据进行处理
  // loadinginstace.close();
  // 对登陆超时进行处理
  if(res.data.code == 1000){
    setLogin(false);
    MessageBox.alert('会话过期，请重新登录', '提示',{
      confirmButtonText: '确定',
      callback: action => {
        window.location.href="/login"
      }
    })
  }
  if(res.data.code != 200 && res.data.code != 4028 && res.data.code != 4029){
    Message.error({
        message:`${res.data.msg}`
    })
    // console.log(`请求失败:${res.data.message}`)
  }
   if(res.data.data&&res.data.data.accessTokenE){
      localStorage.setItem('accessTokenE', res.data.data.accessTokenE)
    }
  return res.data;
},function(err){
  //Do something with response error
    // console.log(err)
    // loadinginstace.close();
    Message.error({
        message:"请求失败,可能是网络错误，"+err
    })
  return  Promise.reject("请求失败,可能是网络错误，"+err);
})

export default axios
